import { useState } from 'react';
import { Link } from 'react-router-dom';
import { products, categories } from '../../../mocks/products';
import { useCart } from '../../../context/CartContext';

export const ProductCard = ({ product }: { product: typeof products[0] }) => {
  const { addToCart } = useCart();
  const [added, setAdded] = useState(false);

  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    addToCart({
      id: product.id,
      name: product.name,
      price: product.price,
      type: product.category === 'evil-energy-destroy-kit' ? 'kit' : 'product',
      image: product.image,
      description: product.description,
    });
    setAdded(true);
    setTimeout(() => setAdded(false), 1500);
  };

  const isBlueProtect = product.category === 'blue-protect';

  return (
    <Link
      to={`/shop/${product.id}`}
      className={`group bg-[#110020]/70 border rounded-2xl overflow-hidden transition-all duration-300 block cursor-pointer ${
        isBlueProtect
          ? 'border-violet-500/30 hover:border-violet-500/60'
          : 'border-violet-500/12 hover:border-violet-500/35'
      }`}
    >
      {/* Image */}
      <div className="relative h-52 overflow-hidden">
        <img
          src={product.image}
          alt={product.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        {product.badge && (
          <span className="absolute top-3 left-3 px-3 py-1 bg-gradient-to-r from-violet-600 to-fuchsia-600 text-white text-xs font-bold rounded-full">
            {product.badge}
          </span>
        )}
        {product.originalPrice && (
          <span className="absolute top-3 right-3 px-2 py-1 bg-pink-600/80 text-white text-xs font-bold rounded-lg">
            -{Math.round((1 - product.price / product.originalPrice) * 100)}%
          </span>
        )}
        {isBlueProtect && (
          <div className="absolute bottom-3 right-3 w-7 h-7 flex items-center justify-center rounded-full bg-violet-600/60 backdrop-blur-sm">
            <i className="ri-shield-star-line text-white text-xs" />
          </div>
        )}
      </div>

      {/* Info */}
      <div className="p-4">
        <p className="text-violet-400/60 text-xs uppercase tracking-wide mb-1">
          {categories.find(c => c.id === product.category)?.label || product.category}
        </p>
        <h3 className="text-white font-semibold text-sm mb-2 leading-snug">{product.name}</h3>
        <p className="text-white/35 text-xs leading-relaxed mb-3 line-clamp-2">{product.description}</p>

        {/* Rating */}
        <div className="flex items-center gap-2 mb-4">
          <div className="flex items-center gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <i key={i} className={`ri-star-fill text-xs ${i < Math.floor(product.rating) ? 'text-[#d4a017]' : 'text-white/15'}`} />
            ))}
          </div>
          <span className="text-white/35 text-xs">{product.rating} ({product.reviews})</span>
        </div>

        {/* Price & Add */}
        <div className="flex items-center justify-between">
          <div>
            <span className="text-white font-bold text-lg">&euro;{product.price.toFixed(2)}</span>
            {product.originalPrice && (
              <span className="text-white/25 text-xs line-through ml-1">&euro;{product.originalPrice.toFixed(2)}</span>
            )}
          </div>
          <button
            onClick={handleAdd}
            className={`flex items-center gap-1.5 px-3 py-2 rounded-xl text-xs font-semibold whitespace-nowrap transition-all duration-300 cursor-pointer ${
              added
                ? 'bg-violet-600 text-white'
                : 'bg-violet-600/15 text-violet-300 hover:bg-violet-600/30 border border-violet-500/20'
            }`}
          >
            {added ? (
              <><i className="ri-check-line" /> Toegevoegd</>
            ) : (
              <><i className="ri-shopping-bag-line" /> In Wagen</>
            )}
          </button>
        </div>
      </div>
    </Link>
  );
};
